module.exports = __webpack_public_path__ + "img/qrec_scheme-20-20.d0e30d56.png";